import React from 'react';
import { Stack, Typography } from '@mui/material';
import ConnectionActiveImports from '@features/connections/generic/components/ConnectionActiveImports';
import { APP_CONFIG } from '../../../../config/app.config';
import SalesOnboardingPanel from './SalesOnboardingPanel';

const SalesImportOverlay: React.FC = () => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <SalesOnboardingPanel
      title="Importing your sales"
      footer={
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
          Depending on the size of your shop, this can take a while.
        </Typography>
      }
    >
      <Typography variant="body2" color="text.secondary">
        We&apos;re importing your orders so we can build your sales overview and forecasts.
      </Typography>

      <Stack
        sx={{
          border: `1px solid ${colors.border}`,
          borderRadius: '8px',
          maxHeight: 220,
          overflowY: 'auto',
        }}
      >
        <ConnectionActiveImports />
      </Stack>
    </SalesOnboardingPanel>
  );
};

export default SalesImportOverlay;
